module.exports = "./img/88a15c4e255937ead1e162e2245c1baf.jpg";